// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://172.10.10.150:94' ;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://expenseapi.sarahtech.com';

const apiConfig = {
    baseURL: API_BASE_URL,
    isDevelopment: process.env.NODE_ENV === 'development',
    isProduction: process.env.NODE_ENV === 'production',
};

export { API_BASE_URL };
export default apiConfig;
